
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private marks: any;
  @Watch("marks", { immediate: true })
  private marksChange() {
    if (this.marks) {
      // 处理格式
      let arr: any = [];
      for (const key in this.marks) {
        if (Object.prototype.hasOwnProperty.call(this.marks, key)) {
          const element = this.marks[key];
          const obj = {
            name: Number(key),
            value: element,
          };
          arr.push(obj);
        }
      }
      this.data = arr;
    }
  }
  @Prop()
  private ifShow: any;
  private data: any;
  private forceUpdate() {
    this.$forceUpdate();
  }
  private cancel() {
    this.$emit("cancel");
  }
  private addOne() {
    this.data.push({
      name: 0,
      value: "",
    });
    this.$forceUpdate();
  }
  private delOne(i: any) {
    this.data.splice(i, 1);
  }
  private makeSure() {
    let result: any = {};
    this.data.forEach((ele: any) => {
      if (ele.name || ele.name === 0) {
        result[ele.name] = ele.value;
      }
    });
    this.$emit("update", result);
  }
}
